import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const config = {
    id: ActionType.ANIM_CORNER_MARK,
    content: i18n.t('隐藏全部角标'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.content,
        text: config.content,
    },
];
